/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { ProcessingUserList, ProcessingUserDetails } from './components';
import { SelectedProcessingUserProvider } from './context';

export const ProcessingUsers = () => {
  return (
    <SelectedProcessingUserProvider>
      <Routes>
        <Route path="/" element={<ProcessingUserList />} />
        <Route path="/:userId" element={<ProcessingUserDetails />} />
      </Routes>
    </SelectedProcessingUserProvider>
  );
};
